import React from 'react'
import { Route,useNavigate,Routes } from 'react-router-dom'
import Tasky from './Tasky'
import Sign from './Sign'


function App() {
  return (
    <div>
      <Routes>
        <Route path='/' Component={Tasky}></Route>
        <Route path='/Sign' Component={Sign}></Route>
      </Routes>
    </div>
  )
}

export default App
